<template>
  <SysDialog v-model="dialog_ativo" ocultar-acoes :largura="450">
    <template #ativador>
      <v-btn
        icon
        color="green"
        title="Produto em processo de compra"
        @click.stop="dialog_ativo = true;buscarPedido();"
      >
        <v-icon>$CartCheck</v-icon>
      </v-btn>
    </template>

    <template #titulo>
      <div>
        <p class="ma-0 pa-0">Produto em processo de compra</p>
        <p class="ma-0 pa-0 mt-n3 font-12 font-weight-regular text-gray-800">
          A compra deste produto não foi confirmada no ERP
        </p>
      </div>

      <v-spacer />

      <v-btn icon @click="dialog_ativo = ! dialog_ativo">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <div class="text-center">
      <p class="ma-0 font-14">
        <span class="font-weight-medium">ID Pedido Systock: </span>
        {{ pedido_compra_nao_confirmada.idpedido }}
      </p>

      <p class="ma-0 font-14">
        <span class="font-weight-medium">Data de Emissão: </span>
        {{ pedido_compra_nao_confirmada.data_emissao }}
      </p>

      <p class="ma-0 font-14">
        <span class="font-weight-medium">Nome do Comprador: </span>
        {{ pedido_compra_nao_confirmada.nome_usuario }}
      </p>

      <p class="ma-0 font-14">
        <span class="font-weight-medium">Quantidade: </span>
        {{ formatarValor(pedido_compra_nao_confirmada.qtde_pedido) }}
      </p>

      <v-btn icon color="primary" class="mt-1" @click="irParaTelaPedidosCompra">
        <v-icon :size="20">mdi-open-in-new</v-icon>
      </v-btn>

      <v-divider class="mt-1" />

      <v-btn class="mt-3" small color="warning" rounded @click="fazerNovoPedidoCompra">
        Ativar para novo pedido
      </v-btn>
    </div>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {ref} from "vue";
import api from "@/api/api";
import store from "@/store";
import {formatarValor, logout} from "@/helpers";
import router from "@/router";

const props = defineProps({
  id_grupo: Number,
  produto_eh_combinacao: Boolean,
  idproduto: String,
});

const emit = defineEmits(['fazer-novo-pedido-compra']);

const dialog_ativo = ref(false);
const pedido_compra_nao_confirmada = ref({});

function buscarPedido() {
  const params = {
    id_grupo: props.id_grupo,
    produto_eh_combinacao: props.produto_eh_combinacao ? 'S' : 'N',
    idproduto: props.idproduto,
  };

  store.dispatch('loading/addRequisicao',
    api.get('pedidos-compra/pedido-compra-produto-nao-confirmado-erp', {params})
      .then(resposta => {
        pedido_compra_nao_confirmada.value = resposta.data.pedido;
      })
      .catch(logout)
  );
}

function irParaTelaPedidosCompra() {
  router.push({
    name: "pedido",
    query: {
      idusuario: pedido_compra_nao_confirmada.value.id_usuario,
      idpedido: pedido_compra_nao_confirmada.value.idpedido
    }
  })
}

function fazerNovoPedidoCompra() {
  dialog_ativo.value = false;
  emit('fazer-novo-pedido-compra', {});
}
</script>
